import * as React from "react";
import { useReferenceContextProvider } from "../../../Core/ReferenceContextProvider";
import { WaveformType } from "../interfaces/state";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";
import { useCoughMarshalApiClient } from "../../../misc/api/CoughMarshalApiClient";
import { CoughAnalysisSetsFixedCommentsDisplay } from "../../../misc/api/apiTypes";
import { CoughAnalysisSetTypeEnum } from "../../../misc/api/CoughAnalysisSetTypes";

interface WaveformSelectorProps {
    primaryAnalysisSetId: string;
    primaryAnalysisSet: CoughAnalysisSetsFixedCommentsDisplay;
    sessionId: string;
    waveformSelected: string;
    onChange: (value) => string;
}

export const WaveformSelector = ({ primaryAnalysisSetId, primaryAnalysisSet, sessionId, waveformSelected, onChange }: WaveformSelectorProps) => {
    const { coughWaveformTypes } = useReferenceContextProvider();
    const [availableWaveforms, setAvailableWaveforms] = React.useState([]);
    const [selectedSessionWaveformType, setSelectedSessionWaveformType] = React.useState<string>();
    const webPortalClient = useWebPortalApiClient();
    const coughMarshalClient = useCoughMarshalApiClient();

    React.useEffect(() => {
        const getSessionWaveforms = async () => {
            if (coughWaveformTypes && coughWaveformTypes.length > 0) {
                const recordingDurations = await coughMarshalClient.getRecording(sessionId, "rawDuration,processedDuration,sensorProcessedDuration,vtaCt1Duration");

                const rawExists = coughWaveformTypes.find(cwt => cwt.id === WaveformType.CWFT_RAW)
                const processedExists = coughWaveformTypes.find(cwt => cwt.id === WaveformType.CWFT_PROCESSED && recordingDurations.processedDuration > 0);
                const sensorProcessExists = coughWaveformTypes.find(cwt => cwt.id === WaveformType.CWFT_SENSOR_PROCESSED && recordingDurations.sensorProcessedDuration > 0);
                const vtaCt1Exists = coughWaveformTypes.find(cwt => cwt.id === WaveformType.CWFT_VTA_CT1 && recordingDurations.vtaCt1Duration > 0);
                const selectedSessionWaveformTypeConst = (await webPortalClient.client.getCoughAnalysisSet(primaryAnalysisSetId)).sessionWaveform;

                setSelectedSessionWaveformType(selectedSessionWaveformTypeConst);

                setAvailableWaveforms([
                    rawExists,
                    processedExists,
                    sensorProcessExists,
                    vtaCt1Exists
                ].filter(w => w));
            }
        }

        getSessionWaveforms();
    }, [coughWaveformTypes]);

    if (availableWaveforms && availableWaveforms.length > 0) {
            return (
                <select
                    id="ToggleWaveform"
                    className="btn btn-primary"
                    disabled={primaryAnalysisSet?.Type?.Id === CoughAnalysisSetTypeEnum.AbacasCoughCount}
                    value={waveformSelected}
                    onChange={e => {
                        e.target.blur();
                        onChange(e.target.value);
                    }}>
                    {availableWaveforms.map(x => x.id === selectedSessionWaveformType ? (
                        <option key={x.id} value={x.id}>
                            QC: {x.name}
                        </option>
                    ) : (
                        <option key={x.id} value={x.id}>
                            {x.name}
                        </option>
                    ))}
                </select>
            );
    } else {
        return null;
    }
}
